module.exports = __webpack_public_path__ + "img/ls2.c4103103.png";